import React, { PropsWithChildren } from "react";

import styles from "./CardsRow.module.css";

interface CardsRowProps {
  children: React.ReactNode;
  maxColumns?: number;
}

const CardsRow: React.FC<PropsWithChildren<CardsRowProps>> = ({
  children,
  maxColumns = 2,
}) => {
  return (
    <div
      style={{ gridTemplateColumns: `repeat(${maxColumns}, 1fr)` }}
      className={styles.container}
    >
      {children}
    </div>
  );
};

export default CardsRow;
